import * as React from 'react'
import {postier} from './Postier'
import {AppContext} from '../../Context/AppContext'

import logo from "./logo.png"
import "./login.scss"
import { Error } from 'react-error-popup'

export function Login() {

    const [username, setUsername] = React.useState("")
    const [password, setPassword] = React.useState("")
    const {setToken,setUserId, errors, setErrors, setRole} = React.useContext(AppContext)

    const connexion = (e)=>{
        e.preventDefault()
        postier.getToken(username,password,setToken,setUserId, setErrors, setRole)
    }

    return (
        <div className="container">
            <form onSubmit={connexion}>
                <img src={logo} alt="logo" width="300"/>
                <h1>Veuillez vous connecter</h1>
                <input type="text" onChange={e=>setUsername(e.target.value)} placeholder="username"/>
                <input type="password" onChange={e=>setPassword(e.target.value)} placeholder="password"/>
                <button>connexion</button>

            </form>
            <Error listError={errors} setListError={setErrors} />
        </div>
    )
}
